module.exports = __webpack_public_path__ + "img/mon_64.901acc7c.png";